/* eslint-disable react-hooks/exhaustive-deps */
import { useSystemActions } from "@_recoil/_actions";
import { systemAtom } from "@_recoil/_state";
import { Fragment, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { UniProfileWrapper } from "@modules/study/university";
import { UniCourseDetails } from "@modules/study/university/uni_course_details";
import { useIsMount } from "@unisearch/common";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import { excerpt } from "@unisearch/helpers";

const CourseDetails = ({
  universityProfileData,
  courseDetailsData,
  country_name,
  university_name,
  course_slug,
}) => {
  //get system info
  const systemInfo = useRecoilValue(systemAtom);
  const systemActions = useSystemActions();
  //get is mounted
  const isMount = useIsMount();
  const [courseDetails, setCourseDetails] = useState();

  //get courses Details information
  const getCourseData = async (currency) => {
    systemActions.setLoading(true);
    await API.get(
      `/public/university-course/single-course/${course_slug}?currencyCode=${
        currency ? currency : ""
      }`
    ).then((resp) => {
      if (!resp.error && resp.data) {
        setCourseDetails(resp.data);
      } else {
        setCourseDetails("");
      }
    });
    systemActions.setLoading(false);
  };

  useEffect(() => {
    if (isMount) {
      setCourseDetails(courseDetailsData);
    } else {
      getCourseData(systemInfo.currency);
    }
  }, [isMount, systemInfo.currency]);

  const metaDescription = courseDetailsData?.course?.metaDescription
    ? courseDetailsData?.course?.metaDescription
    : courseDetailsData
    ? excerpt(courseDetailsData.course.courseDescription, 400)
    : "";

  const JsonLd = () => {
    {
      return {
        __html: `
        {
          "@context": "https://schema.org",
          "@type": "Course",
          "name": "${courseDetailsData?.course?.courseName}",
          "description": "${metaDescription} | UniSearch",
          "provider": {
            "@type": "Organization",
            "name": "${universityProfileData?.universityName}",
            "sameAs": "${universityProfileData?.website}"
          }
        }
    `,
      };
    }
  };

  return (
    <LayoutMain
      footer_with_evaluation
      title={
        universityProfileData
          ? `${universityProfileData?.universityName} - ${courseDetailsData?.course?.courseName}`
          : ""
      }
      metaTitle={courseDetailsData?.course?.metaTitle}
      metaKeywords={courseDetailsData?.course?.metaKeyword}
      metaDescription={metaDescription}
      metaImage={
        universityProfileData?.coverphotoLogoSrc
          ? universityProfileData?.coverphotoLogoSrc
          : universityProfileData?.featureSrc
      }
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/study/${country_name}/university/${university_name}/${course_slug}`}
      JsonLd={JsonLd}
    >
      <Fragment>
        <UniProfileWrapper
          breadcrumbTitle={courseDetailsData?.course?.courseName}
          uniProfileData={universityProfileData || {}}
        >
          <UniCourseDetails
            courseDetailsData={courseDetails}
            universityProfileData={universityProfileData}
          />
        </UniProfileWrapper>
      </Fragment>
    </LayoutMain>
  );
};

export default CourseDetails;

export async function getServerSideProps({ params, query }) {
  const { country_name, university_name, course_slug } = params;
  const { currencyCode } = query;

  let props = {
    universityProfileData: "",
    courseDetailsData: "",
    country_name,
    university_name,
    course_slug,
  };

  try {
    await API.get(`/public/university/${university_name}`).then((resp) => {
      if (!resp.error && resp.data) {
        props.universityProfileData = resp.data;
      }
    });

    const courses = await API.get(
      `/public/university-course/single-course/${course_slug}?currencyCode=${
        currencyCode ? currencyCode : ""
      }`
    );
    if (!courses.error && courses.data) {
      props.courseDetailsData = courses.data;
    } else {
      return {
        redirect: {
          permanent: false,
          destination: "/404",
        },
      };
    }
    return {
      props,
    };
  } catch (err) {
    return {
      redirect: {
        permanent: false,
        destination: "/404",
      },
    };
  }
}
